import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import RegistrationService from '../services/registration';
import ProfileService from '../services/Profile';
import toast from "react-hot-toast";
import { logoutHandler } from '../constants/commonFunction';
import { Container, Row, Col } from 'react-bootstrap';
import SelectDropDown from "../component/SelectDropDown";

import PrimaryGradientButton from '../component/PrimaryGradientButton'
import AlertMsg from "../component/AlertMsg";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { addTotalCartItems } from '../redux/slices/countSlice';
import NoData from '../component/NoData';
// import { useNavigate } from 'react-router-dom';
 

function BrandEnrollment(route) {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const totalBrands = useSelector((state) => state?.userTypeSlice?.totalBrands);
  // useSelector(
  //   state => state.userTypeSlice.totalBrands,
  // );

  const [district, setDistrict] = useState({id: '', title: ''});
  const [selectedTaluka, setSelectedTaluka] = useState({id: '', title: ''});
  const [allTaluka, setAllTaluka] = useState([]);
  const [state, setState] = useState({id: '', title: ''});
  const [loading, setLoading] = useState(false);
  const [selectedOfficer, setSelectedOfficer] = useState({id: '', title: ''});
  const [brand, setBrand] = useState({id: '', title: ''});
  const [selectedOffMember, setSelectedOffMember] = useState({
    id: '',
    title: '',
  });
  const [allBrands, setAllBrands] = useState([]);
  const [brandType, setBrandType] = useState([]);
  const [initLoader, setInitLoader] = useState(true);
  const [selLang, setSelLang] = useState('');
  const [hierName, setHiername] = useState(null);
  const [userName, setUserName] = useState('');
  const [country, setCountry] = useState({id: '', title: ''});
  const [statelist, setStatelist] = useState([]);
  const [allDistrict, setAllDistrict] = useState([]);
  const [allOffMembers, setAllOffMember] = useState([]);
  const [check1, setCheck1] = useState(1);
  const [check2, setCheck2] = useState(1);
  const dealerOrTse = [
    {
      id: 'TSE',
      title: 'TSE/TE',
    },
    {
      id: 'Dealer',
      title: 'Dealer',
    },
  ];
  const [showAlert, setShowAlert] = useState(false);
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
});
const [isButtonLoading, setIsButtonLoading] = useState(false);
const [brandValidationErrors, setBrandValidationError] = useState("");

  // 
  const handleLogOut = ()=>{
    localStorage.clear();
     window.location.reload();
    dispatch(addTotalCartItems({
        cartCount:0
    }))
    navigate('/');
   
}
// const handleLogOut = () => {
//   localStorage.clear();
//   dispatch(addTotalCartItems({ cartCount: 0 }));
//   navigate('/');
// };

  // 
  useEffect(() => {
    setDistrict({id: '', title: ''});
    setSelectedTaluka({id: '', title: '', ext_taluka_code: ''});
    setAllTaluka([]);
  }, [state]);

  // 
  useEffect(() => {
    setSelectedTaluka({id: '', title: ''});
  }, [district]);

  // Submit handler
  const submitHandler = async () => {
    try {
      setLoading(true);
      let payload = {
        organization_Id: 2,
        brand_id: brand.id,
        taluka_id: selectedTaluka.id,
        select_TSE_or_dealer: selectedOfficer.id,
      };
  
      if (selectedOfficer.id === 'TSE') {
        payload = { ...payload, tse_id: selectedOffMember.id };
      } else if (selectedOfficer.id === 'Dealer') {
        payload = { ...payload, dealer_arr: [selectedOffMember.id] };
      }
  
  
      const res = await RegistrationService.brandEnrollment(payload);
  
      if (res.success) {
        // alert(JSON.stringify( {
        //   data: {
        //     isSuccess: true,
        //     heading: 'Brand enrollment applied successfully. Please log in again',
        //     describe: res.response.message,
        //   },
        // }));
        toast.success('Brand enrollment applied successfully. Please log in again')
        // logoutHandler(navigate);
        // handleLogOut();

        setTimeout(() => {
          handleLogOut();
        }, 5000);
        // setTimeout(() => {
        //   toast.info('Logging you out...');
        //   setTimeout(() => {
        //     handleLogOut();
        //   }, 2000); // Wait 2 seconds before actually logging out
        // }, 1500);
      } else {
        // alert(JSON.stringify( {
        //   data: {
        //     isSuccess: false,
        //     heading: res.response.message,
        //   },
        // }));
        toast.error(res.response.message);
      }
    } catch (err) {
      console.error("Error");
  
      // alert(JSON.stringify( {
      //   data: {
      //     isSuccess: false,
      //     heading: 'Something went wrong. Please try again.',
      //   },
      // }));
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false); 
    }
  };

  // Get login brand
  const getBrand = async (payload) => {
    try {
      const res = await ProfileService.getLoginBrand(payload);
  
      if (res.success === true) {
        if (res.response.length === allBrands.length) {
          // setSlide(0);
        }
        if (res.response.length === 1) {
          // setSlide(1);
          let loginBrandId = res.response[0].brand_id;
  
          let brands = allBrands
            .filter((item) => item.id !== String(loginBrandId))
            .map((item) => {
              return {
                ...item,
                // image: { uri: IMAGE_BASE_URL + item.image.uri }, 
              };
            });
  
          setBrandType(brands);
        }
        setInitLoader(false);
      } else {
        setBrandType([]);
        setInitLoader(false);
      }
    } catch (err) {
      setInitLoader(false);
    }
  };

  // Get all brands
  const getAllBrand = async () => {  
    try {
      const res = await ProfileService.getBrand();
  
      if (res.success === true) {
        const brands = res.response.message.map((item) => {
          return {
            id: String(item.brandId),
            title: item.brandName,
            // image: { uri: IMAGE_BASE_URL + item.brandLogo }, 
          };
        });
  
         //--->show hochche
        setAllBrands(brands);
      } else {
        setAllBrands([{
          id: '',
          title: '',
          // image: '',
        }]);
      }
    } catch (err) {
    }
  };

  // 
useEffect(() => {
  const getAllData = async () => {
    await getAllBrand();

    const token = localStorage.getItem('access_token');

    const lang = localStorage.getItem('lang');
    setSelLang(lang); 

    const desc = JSON.parse(localStorage.getItem('userData')).hierCode;
    setHiername(desc);

    const name = JSON.parse(localStorage.getItem('userData')).username;
    setUserName(name);
  };

  getAllData();
}, []); 

// 
useEffect(() => {
  const token = localStorage.getItem('access_token');
  if (hierName && userName && allBrands.length > 0) {
    const payload = {
      userType: hierName.toLowerCase(),
      username: userName,
    };
    getBrand(payload);
  }
}, [hierName, userName, allBrands]);

// country list
const getCountryList = async () => {
  try {
    const res = await RegistrationService.allCountries();

    if (res.success) {
      const allCountries = res.response.countriesDetails
        .filter((item) => ['India'].includes(item.name))
        .map((item) => ({ id: item.id, title: item.name }));

      setCountry({id: allCountries[0].id, title: allCountries[0].title});

    //   if (allCountriesList.length > 0) {
    //     setSelectedCountry(allCountriesList[0]);
    //   }
    } else {
      console.error('Error fetching countries:');
    }
  } catch (err) {
    console.error('Error:');
  }
};

// state list
const getStateList = async (cid) => {
  try {
    const res = await RegistrationService.allStates(100);
    if (res.success) {
      const allState = res.response.statesDetails.map((item) => ({
        id: item.id,
        title: item.name,
      }));

      setStatelist(allState);
    } else {
      console.error('Error fetching states:');
    }
  } catch (err) {
    console.error('Error:');
  }
};

// district list from country & state
useEffect(() => {
  if (state.id && country.id) {
    RegistrationService.allDistricts(country.id, state.id).then(res => {

      if (res.success) {
        const districts = res.response.districtDetails.map(dis => ({
          id: dis.id,
          title: dis.name,
        }));
        setAllDistrict(districts);
      }
    });
  }
  // });
}, [state, country]);

// 
useEffect(() => {
  getCountryList();
}, []);

// 
useEffect(() => {
  if (country.id) {
    getStateList(country.id);
  }
}, [country]);

// 
useEffect(() => {
  if (district.id) {
    RegistrationService.talukasByDistrict(district.id).then(res => {
      if (res.success) {
        const talukas = res.response.talukaDetails.map(taluka => ({
          id: taluka.id,
          title: taluka.name,
        }));

        setAllTaluka(talukas);
      }
    });
  }
}, [district]);

// 
useEffect(() => {
  const fetchDealersOrTSE = async () => {

    if (brand?.id && selectedTaluka?.id && district?.id && selectedOfficer?.id) {
      const payload = {
        userContactId: 0,
      };    
      try {
        const res = await RegistrationService.getDealersOrTse(
          selectedOfficer.id,
          district.id,
          selectedTaluka.id,
          brand.id,
          payload,
        );
    
        if (res.success) {
          const offs = res.response.adminDetails.map(off => ({
            id: off.id,
            title: off.full_name,
          }));
          setAllOffMember(offs);
        }
      } catch (err) {
        console.error('Error fetching dealers or TSE:');
      }
    }
  };
  fetchDealersOrTSE();
}, [brand, selectedOfficer, district, selectedTaluka]);

// 
useEffect(() => {
  setSelectedOfficer({
    id: '',
    title: '',
  });
  setSelectedOffMember({
    id: '',
    title: '',
  });
}, [district, selectedTaluka, state]);

const handleBrandChange = (selected) => {
  setAllBrands(selected);
  setBrandValidationError('')
}
  
return (
  <>
      {/* {loading && <Loader />} */}

      <BreadCrumbSecttion pageTitle="Brand Enrollment" currentPageName="Brand Enrollment" />
      <section className='padTop50'>
          <Container>
              <Row className='justify-content-center align-item-center h-100'>
                  <Col xs={12} >
                      {totalBrands.length < 2 && <div className='userInfoBox'>
                          {/* <div className='dashboard-title'> */}
                              {/* <h4>Brand Enrollment</h4> */}
                          {/* </div> */}
                          <div className="dashboard-details">
                              <Row>
                              <Col xs={12} lg={3} className='mb-2'>
                                                <SelectDropDown
                                                    labelName="Brand"
                                                    requiredStar="*"
                                                    options={brandType}
                                                    selectedValue={brand}
                                                    setSelectedValue={setBrand}
                                                    onChange={handleBrandChange}
                                                    page='searchFilter'
                                                />
                                                {/* {brandValidationError && (
                                                    <div className="error-message">
                                                        {brandValidationError}
                                                    </div>
                                                )} */}
                                            </Col>

                                            <Col xs={12} lg={3} className='mb-2'>
                                                <SelectDropDown
                                                    labelName="State"
                                                    requiredStar="*"
                                                    options={statelist}
                                                    selectedValue={state}
                                                    setSelectedValue={setState}
                                                    // onChange={handleBrandChange}
                                                    page='searchFilter'
                                                />
                                                {/* {brandValidationError && (
                                                    <div className="error-message">
                                                        {brandValidationError}
                                                    </div>
                                                )} */}
                                            </Col>

                                            <Col xs={12} lg={3} className='mb-2'>
                                                <SelectDropDown
                                                    labelName="District"
                                                    requiredStar="*"
                                                    options={allDistrict}
                                                    selectedValue={district}
                                                    setSelectedValue={setDistrict}
                                                    // onChange={handleBrandChange}
                                                    page='searchFilter'
                                                />
                                                {/* {brandValidationError && (
                                                    <div className="error-message">
                                                        {brandValidationError}
                                                    </div>
                                                )} */}
                                            </Col>

                                            <Col xs={12} lg={3} className='mb-2'>
                                                <SelectDropDown
                                                    labelName="Taluka"
                                                    requiredStar="*"
                                                    options={allTaluka}
                                                    selectedValue={selectedTaluka}
                                                    setSelectedValue={setSelectedTaluka}
                                                    // onChange={handleBrandChange}
                                                    page='searchFilter'
                                                />
                                                {/* {brandValidationError && (
                                                    <div className="error-message">
                                                        {brandValidationError}
                                                    </div>
                                                )} */}
                                            </Col>

                                            <Col xs={12} lg={3}>
                                            <SelectDropDown
                                                labelName="Select Dealer or TSE/TE"
                                                requiredStar="*"
                                                options={dealerOrTse}    
                                                selectedValue={selectedOfficer}
                                                setSelectedValue={setSelectedOfficer}
                                                // onChange={handleOfficerChange}
                                                page='searchFilter'
                                            />
                                            {/* {officerValidationError && (
                                                <div className="error-message">
                                                    {officerValidationError}
                                                </div>
                                            )} */}
                                        </Col>

                                        <Col xs={12} lg={3}>
                                        {selectedOfficer.title && (
                                        <>
                                          <SelectDropDown
                                            labelName={selectedOfficer.title}
                                            options={allOffMembers}
                                            selectedValue={selectedOffMember}
                                            setSelectedValue={setSelectedOffMember}
                                            page="searchFilter"
                                          />
                                          {/* {offMemberValidationError && (
                                            <div className="error-message">
                                              {offMemberValidationError}
                                            </div>
                                          )} */}
                                        </>
                                       )}
                                    </Col>

                                    <Col xs={12} lg={3} className="mt-4">
                                      <PrimaryGradientButton
                                        buttonText={isButtonLoading ? "Processing" : "Submit"}
                                        disabled={isButtonLoading}
                                        onClick={submitHandler}
                                      />
                                    </Col>

                                    {/* <Col xs={12} lg={3}>

                                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            }
                                        </Col> */}

                              </Row>
                          </div>
                      </div>}
                      {totalBrands.length === 2 && <NoData title='You are assigned to both the brands' />}
                  </Col>
              </Row>
          </Container>
      </section>

  </>
)
}

export default BrandEnrollment